import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, IconButton, TextField, Typography, Grid, DialogActions, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, CircularProgress, Select, OutlinedInput, Chip, Box, MenuItem } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import Toggle from 'react-toggle';
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import { DEFAULT_LOCKOUT, DEFAULT_MASTERY_COUNT, DEFAULT_MAXIMUM_ATTEMPT, DEFAULT_NOCQC, DEFAULT_RANDOMIZE_CATEGORIES, DEFAULT_END_SPLASH_SCREEN_TEXT } from '../Constants';
import { DatePicker, TimePicker } from 'react-md';
import moment from 'moment';
import SectionSubsectionDialog from './SectionSubsectionDialog';

const NewAssignmentModal = ({
    showModal,
    handleClose,
    course_id,
    selectedCourse,
    onCompleteCreateAssignment,
    isLibrary,
    librarySubjectID,
    libraryTopicID,
    libraryMatrixID
}) => {

    const [assignmentName, setAssignmentName] = useState("");
    const [isTest, setIsTest] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [sections, setSections] = useState([]);
    const [subsections, setSubsections] = useState([]);
    const [hasSubSections, setHasSubSections] = useState(false);
    const [enableSubSection, setEnableSubSection] = useState(false);
    const [selectedSectionIDArr, setSelectedSectionIDArr] = useState([]);
    const [selectedSubsectionsArr, setSelectedSubsectionsArr] = useState([]);
    const [selectedSectionAndSubsectionList, setSelectedSectionAndSubsectionList] = useState([]);
    const [showSectionsAndSubsectionsDialog, setShowSectionsAndSubsectionsDialog] = useState(false);


    useEffect(() => {
        if (course_id) {
            getCourseSections();
        }
    }, [])

    const getCourseSections = () => {
        let payload = {
            course_id: course_id
        }
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
        }).then(async (res) => {
            if (res && res.data && res.data.data) {
                let sectionsArr = res.data.data.section_names;
                let subsectionsArr = [];
                let hasSubSections = false;

                let index = sectionsArr?.findIndex(sec => sec.enable_subsection);
                if (index >= 0) hasSubSections = true;

                // get all subections for sections has enabled
                for (let i = 0; i < sectionsArr.length; i++) {
                    const section = sectionsArr[i];
                    if (section.enable_subsection) {
                        const subsections = await getSubsections({
                            course_id: course_id,
                            section_id: section.section_id
                        })
                        subsectionsArr.push(...subsections);
                    }
                }

                setSections(sectionsArr);
                setSubsections(subsectionsArr);
                setHasSubSections(hasSubSections);
            }
        })
    }

    const getSubsections = async (payload) => {
        const res = await ApiRequestService({
            method: 'post',
            url: '/getAllSubSections',
            data: payload
        })
        if (res.data && res.data.data && res.data.data.subsection_names != null && res.data.data.subsection_names.length > 0) {
            return res.data.data.subsection_names;
        } else {
            return [];
        }
    }

    const onSaveSectionSubsection = (data, editMode, oldData) => {
        let tempList = [...selectedSectionAndSubsectionList];
        console.debug("editMode>>??", editMode, tempList, data);
        if (editMode) {
            let index = tempList.findIndex(sec => sec.section_id === oldData.section_id);
            if (index > -1) {
                tempList[index] = data;
            }
        } else {
            tempList.push(data);
        }
        setSelectedSectionAndSubsectionList(tempList)
    }

    const onDeleteSectionSubsection = (index) => {
        if (index > -1) {
            let tempList = [...selectedSectionAndSubsectionList];
            tempList.splice(index, 1);
            setSelectedSectionAndSubsectionList(tempList);
        }
    }

    const handleSectionSelect = (event) => {
        let tempArr = event.target.value;
        setSelectedSectionIDArr(tempArr);
    }

    const handleCreateAssignment = () => {

        let tempstartDate = startDate;
        let tempendDate = endDate;
        let sDate = "";
        let eDate = "";
        // start_time/due_time are TIME columns; strict-mode MySQL rejects "".
        // Library assignments have no schedule, so default like the detail modal does.
        let sTime = "00:00:00";
        let eTime = "00:00:00";
        let sectionList = [];
        
        if (!isLibrary) {
            if (course_id === null || course_id === undefined) {
                NotificationManager.error('Invalid course id', 'Error', 3000);
                return
            }

            if (startDate === "") {
                NotificationManager.error("Start date should not be empty");
                return;
            }
            if (endDate === "") {
                NotificationManager.error("End date should not be empty");
                return;
            }
            sDate = tempstartDate?.format('DD/MM/YYYY');
            tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
            sTime = tempstartDate[1];

            eDate = tempendDate?.format('DD/MM/YYYY');
            tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
            eTime = tempendDate[1];

            
            // TODO: fix this when enable_subsections is turned ON
            if (enableSubSection) {
                selectedSectionAndSubsectionList.forEach(sec => {
                    //console.debug("sec>>??", sec)
                    sec.subsectionList.forEach(subSec => {
                        sectionList.push({
                            id: sec.section_id,
                            ...subSec,
                        });
                    })
                })
            } else {
                selectedSectionIDArr.forEach(id => {
                    let section = sections.find(sec => sec.section_id === id);
                    if (section) {
                        sectionList.push({
                            id: section.section_id,
                            ...section
                        });
                    }
                })
            }
        }

        let payload = {
            quiz_name: assignmentName,
            quiz_type: isTest ? 1 : 0,
            allow_practice: isTest ? false : true, // by default all quizzes are practicable
            course_id: course_id,
            randomize_categories: DEFAULT_RANDOMIZE_CATEGORIES,
            mastery_condition: DEFAULT_MASTERY_COUNT,
            maximum_attempted: DEFAULT_MAXIMUM_ATTEMPT,
            lockoutN: DEFAULT_LOCKOUT,
            NoCQC: DEFAULT_NOCQC,
            enable_subsection: enableSubSection,
            end_splash_screen: DEFAULT_END_SPLASH_SCREEN_TEXT,
            sections_list: sectionList,
            start_date: sDate,
            start_time: sTime,
            end_date: eDate,
            end_time: eTime,
            status: 0, // by default unpublished
            aml_subject_id: librarySubjectID,
            aml_topic_id: libraryTopicID,
            aml_matrix_id: libraryMatrixID,
        }

        // LTI course assignments are always published
        if (selectedCourse && selectedCourse.is_lti_enabled) {
            payload.status = 1;
        }

        if (!isLibrary) {
            if (payload.sections_list === null || payload.sections_list?.length === 0) {
                let msg = "Please add atleast one section"
                if (payload.enable_subsection) {
                    msg = "Please add atleast one section & subsection"
                }
                NotificationManager.error(msg);
                return;
            }
        }

        console.debug("payload>>??", payload)

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/addQuiz',
            data: payload
        }).then(res => {
            console.debug("res>>??", res)
            // Status, not the data slot: a creation refused by the sync coverage
            // gate answers FAIL carrying the rows that blocked it, so data being
            // present no longer means the assignment was created.
            if (res && res.data && res.data.status === 0 && res.data.data) {
                NotificationManager.success("Created your assignment", "Success", 3000);
                handleClose();
                onCompleteCreateAssignment(res.data.data);
            } else {
                if (res?.data?.message) {
                    NotificationManager.error(res?.data?.message, "ERROR", 12000);
                } else {
                    NotificationManager.error("Unable to create assignment");
                }
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleChangeStartDate = (timeString, sDate, event) => {
        if (sDate !== null) {
            setStartDate(moment(sDate));
        }
    }

    const handleChangeEndDate = (eDate, id) => {
        if (eDate !== null) {
            let date = moment(eDate)
            if (id === "date") {
                date.set({ "h": 23, "m": 59 })
            }

            setEndDate(date);
        }
    }

    const isValidDate = function (d) {
        return d instanceof Date && !isNaN(d);
    }

    let startDateLocal = moment(startDate).toDate();
    let endtDateLocal = moment(endDate).toDate();

    const checkDisabled = () => {
        if (isLibrary) {
            return loading || assignmentName === ""
        }
        return loading || assignmentName === "" || startDate === "" || endDate === ""
    }

    return (
        <Dialog
            maxWidth="sm"
            fullWidth
            open={showModal}
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    New Assignment
                </Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={8}>
                        <TextField
                            placeholder='Enter assignment name'
                            sx={{
                                width: "100%",
                            }}
                            onChange={event => {
                                setAssignmentName(event.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <FormControl >
                                {/* <FormLabel>Assignment</FormLabel> */}
                                <RadioGroup
                                    row
                                    defaultValue={0}
                                    name="row-radio-buttons-group"
                                    onChange={() => {
                                        setIsTest(!isTest);
                                    }}
                                >
                                    <FormControlLabel value={0} control={<Radio />} label="Mastery" />
                                    <FormControlLabel value={1} control={<Radio />} label="Test" />
                                </RadioGroup>
                            </FormControl>

                            {/* <Toggle
                                onChange={() => {
                                    setIsTest(!isTest);
                                }}
                                icons={false} checked={isTest} className='custom-react-toggle'
                            />
                            <div style={{ fontWeight: 600, width: "100%" }}>Test</div> */}
                        </div>
                    </Grid>
                    {isLibrary ? null :
                        <React.Fragment>
                            <Grid item xs={3}>
                                <DatePicker
                                    id="startDate"
                                    label="Start Date"
                                    displayMode="portrait"
                                    value={isValidDate(startDateLocal) ? startDateLocal : null}
                                    onChange={handleChangeStartDate}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TimePicker
                                    id="startTime"
                                    label="Start Time"
                                    displayMode="portrait"
                                    value={isValidDate(startDateLocal) ? startDateLocal : null}
                                    onChange={handleChangeStartDate}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DatePicker
                                    id="endDate"
                                    label="End Date"
                                    displayMode="portrait"
                                    value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                    onChange={(_, date) => handleChangeEndDate(date, "date")}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TimePicker
                                    id="endTime"
                                    label="End Time"
                                    displayMode="portrait"
                                    value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                    onChange={(_, date) => handleChangeEndDate(date, "time")}
                                />
                            </Grid>

                            <Grid item xs={8}>
                                {enableSubSection ?
                                    <div className='section-container'>
                                        <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Section List</div>
                                        <Button variant='contained' onClick={() => {
                                            setShowSectionsAndSubsectionsDialog(true);
                                        }}>
                                            Sections & Subsections
                                        </Button>
                                    </div>
                                    :
                                    <div className='section-container'>
                                        <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Section List</div>
                                        <FormControl fullWidth>
                                            <Select
                                                size='small'
                                                id="section-id"
                                                multiple
                                                value={selectedSectionIDArr}
                                                onChange={handleSectionSelect}
                                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => {
                                                            let section = sections?.find(sec => sec.section_id === value);
                                                            return (
                                                                <Chip className='custom-chip' key={value} label={section?.section_name} />
                                                            )
                                                        })}
                                                    </Box>
                                                )}
                                            >
                                                {sections?.map((section, index) => {
                                                    return (
                                                        <MenuItem key={index} value={section.section_id}>
                                                            {section.section_name}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>}
                            </Grid>
                            <Grid item xs={4}>
                                {hasSubSections ?
                                    <div className='textfield-container'>
                                        <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Choose Subsections</div>
                                        <Toggle checked={enableSubSection} icons={false} className='custom-react-toggle'
                                            onChange={() => {
                                                setSelectedSectionIDArr([]);
                                                setSelectedSectionAndSubsectionList([]);
                                                setEnableSubSection(!enableSubSection);
                                            }}
                                        />
                                    </div>
                                    : null}
                            </Grid>
                        </React.Fragment>
                    }
                </Grid>
                {showSectionsAndSubsectionsDialog ?
                    <SectionSubsectionDialog
                        showDialog={showSectionsAndSubsectionsDialog}
                        selectedSectionAndSubsectionList={selectedSectionAndSubsectionList}
                        handleClose={() => setShowSectionsAndSubsectionsDialog(false)}
                        sections={sections}
                        subSections={subsections}
                        onSaveSectionSubsection={onSaveSectionSubsection}
                        onDeleteSectionSubsection={onDeleteSectionSubsection}
                    />
                    : null}


            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose} disabled={loading}>
                    Close
                </Button>
                <Button variant='contained' onClick={handleCreateAssignment}
                    disabled={checkDisabled()}>
                    <div style={{ opacity: loading ? 0 : 1 }}>
                        Create
                    </div>
                    <div className='abs-center'>
                        {loading && (
                            <CircularProgress size={20} />
                        )}
                    </div>

                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default NewAssignmentModal;
